<template>
  <communication-bots
    :is-loading="isLoading"
    :bots="config.bots"
    :trigger-types="config.triggerTypes"
    :triggers="triggers"
    :raw-config="config.raw"
    @upsert-trigger="onUpsertTrigger"
    @send-test-message="onSendTestMessage"
    @delete-trigger="onDeleteTrigger"
    @update-config="onUpdateConfig"
  />
</template>

<script>
import { API } from '@/utils/api'
import CommunicationBots from '../components/CommunicationBots.vue'

export default {
  components: {
    CommunicationBots,
  },

  data() {
    return {
      isLoading: false,
      config: {
        bots: [],
        triggerTypes: [],

        raw: {},
      },
      triggers: [],
    }
  },

  mounted() {
    Promise.all([
      this.loadConfig(),
      this.loadTriggers(),
    ]).finally(() => this.isLoading = false)
  },

  methods: {
    loadConfig() {
      this.isLoading = true
      return API.call('/$v/tools/communication_bot_trigger/get_config.json')
        .then(r => {
          this.config.bots = r.data.bots;
          this.config.triggerTypes = r.data.trigger_types
          this.config.raw = r.data.raw_config
        })
        .finally(() => { this.isLoading = false })
    },

    loadTriggers() {
      this.isLoading = true
      return API.call('/$v/tools/communication_bot_trigger/list.json')
        .then(r => { this.triggers = r.data })
        .finally(() => { this.isLoading = false })
    },

    onUpsertTrigger(trigger) {
      this.isLoading = true

      return API.call('/$v/tools/communication_bot_trigger/update.json', trigger)
        .then(r => {
          this.$showSuccess('Trigger saved successfully')
          return this.loadTriggers()
        })
        .finally(() => { this.isLoading = false })
    },

    onDeleteTrigger(trigger) {
      this.$root.$confirm('Confirm', 'Delete this trigger?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.isLoading = true
          return API.call('/$v/tools/communication_bot_trigger/delete.json', trigger)
            .then(r => {
              this.$showSuccess('Trigger deleted successfully')
              return this.loadTriggers()
            })
            .finally(() => this.isLoading = false)
        })
    },

    onSendTestMessage(args) {
      this.$root.$confirm('Confirm', 'Send test message to this chat?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.isLoading = true
          return API.call('/$v/tools/communication_bot_trigger/test.json', args)
            .then(r => {
              this.$showSuccess('Test message sent successfully')
            })
            .finally(() => this.isLoading = false)
        })
    },

    onUpdateConfig(args) {
      this.$root.$confirm('Confirm', 'Update bot config?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.isLoading = true
          return API.call('/$v/tools/communication_bot_trigger/set_config.json', args)
            .then(() => this.loadConfig())
            .finally(() => this.isLoading = false)
        })
    }
  },
}
</script>
